import Vue from "vue";
import Maska from "maska";

Vue.use(Maska);
